import { render, staticRenderFns } from "./changeProductDetail.vue?vue&type=template&id=571a9cdc&scoped=true"
import script from "./changeProductDetail.vue?vue&type=script&lang=js"
export * from "./changeProductDetail.vue?vue&type=script&lang=js"
import style0 from "./changeProductDetail.vue?vue&type=style&index=0&id=571a9cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571a9cdc",
  null
  
)

export default component.exports